// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b8c1b9f2","843":"5ec57aa4"}[chunkId] + ".chunk.js";
};